<template>
  <div class="content-box">
    <!-- <el-image src="/static/imgs/hq.png" fit="cover" class="saveimg w-img" /> -->
    <div class="w-art">
      <div class="w1200 cens-aaa isnewstyle" v-if="form.title">
        <div class="artitle">{{form.title}}</div>
        <div v-html="form.content"></div>
      </div>
      <div class="w380 borsart dis">
        <div class="backs" @click="$router.back()">返回上一页</div>
        <div class="backs bluse" @click="$router.push({path:'/save'})">发布询价</div>
      </div>

      <div class="w1200 nexta">
        <div @click="handlePrevious(index-1)">上一篇：<span v-if="index-1>=0">{{pastBox[index-1].title}}</span><span v-else
            class="ishui">没有了</span>
        </div>
        <div @click="handlePrevious(index+1)">下一篇：<span
            v-if="index+1<pastBox.length">{{pastBox[index+1].title}}</span><span v-else class="ishui">没有了</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IndexMarket',
    data() {
      return {
        form: {},
        screenWidth: null,
        pastBox: [],
        index: 0
      }
    },

    watch: {
      '$route': {
        handler(newValue) {
          if (newValue.path.includes('/market/article')) {
            this.getArt(newValue.params.id);
          }
        },
        immediate: true
      }
    },
    methods: {
      handlePrevious(num) {
        if (num >= this.pastBox.length || num < 0) {
          return false
        }
        this.index = num
        this.getArt(this.pastBox[num].id)
        this.goTop()
      },

      getArt(id) {
        this.$request('get', this.$otapi + 'items/market/' + id + '?fields=*.*', {}, (res) => {
          if (res.status == 200) {
            this.form = res.data.data

            this.$request('get', this.$otapi +
              'items/market?page=1&limit=10000&filter={"category": "1","status":"published"}&sort=-date_created&meta=*', {},
              (res) => {
                if (res.status == 200) {
                  this.pastBox = res.data.data
                  this.index = this.pastBox.findIndex(item => item.id == id)
                } else {
                  this.$notify.error({
                    title: '错误',
                    message: '请求失败！',
                    position: 'top-left'
                  });
                }
              })
          }
        })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-资讯详情'

      }
    }
  }
</script>

<style scoped>
  .w1200 {
    width: 900px;
    margin: 0 auto;
  }

  .borsart {
    margin-bottom: 30px;
  }

  .backs {
    width: 181px;
    height: 38px;
    border-radius: 4px;
    border: 1px solid #6B78E5;
    text-align: center;
    line-height: 38px;
    color: #6B78E5;
    font-size: 16px;
    margin: 56px auto;
    cursor: pointer;
  }

  .w380 {
    width: 380px;
    margin: 0 auto;
  }

  .nexta {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 50px;
  }

  .nexta div {
    margin-bottom: 10px;
    cursor: pointer;
  }

  .ishui {
    color: #999;
  }

  .artitle {
    font-size: 32px;
    font-weight: bold;
    color: #000000;
    margin: 50px 0;
  }


  .bluse {
    background: #6B78E5;
    color: #fff;
  }



  .w-art {
    position: relative;
    width: 100%;
  }



  .backs:hover {
    color: #fff;
    background: #2468F2;

  }

  .cens-aaa {
    text-align: center;
  }

  .mao-div {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    border: 2px solid #37393F;
  }

  .max-txt {
    display: block;
    width: 70px;
    text-align: left;
  }

  .nexta div:hover {
    color: #2468F2;
  }
</style>



// WEBPACK FOOTER //
// src/components/market/article.vue